/**
 * Strip markdown syntax to a clean plain-text snippet, for use in list cards
 * where we have limited space and don't want raw markdown like
 * `![screenshot](...)` or `## Features` showing through truncation.
 */
export function stripMarkdown(input: string): string {
  if (!input) return ''
  let s = input
  // Images: ![alt](url) → ''
  s = s.replace(/!\[[^\]]*\]\([^)]*\)/g, '')
  // Links: [text](url) → text
  s = s.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
  // Inline/code blocks: `code` and ```fences```
  s = s.replace(/```[\s\S]*?```/g, '')
  s = s.replace(/`([^`]+)`/g, '$1')
  // Headings: leading #'s
  s = s.replace(/^\s{0,3}#{1,6}\s+/gm, '')
  // Blockquotes
  s = s.replace(/^\s{0,3}>\s?/gm, '')
  // Bullets / numbered lists
  s = s.replace(/^\s*([-*+]|\d+\.)\s+/gm, '')
  // Bold/italic markers
  s = s.replace(/(\*\*|__)(.*?)\1/g, '$2')
  s = s.replace(/(\*|_)(.*?)\1/g, '$2')
  // HTML tags
  s = s.replace(/<[^>]+>/g, '')
  // Collapse whitespace
  s = s.replace(/\s+/g, ' ').trim()
  return s
}
